import React from "react";
import {
 Modal,
 ModalOverlay,
 ModalContent,
 ModalCloseButton,
 ModalBody,
 useDisclosure,
 Button,
 Box,
 useToast,
} from "@chakra-ui/react";
import BtechInquiryForm from "./BtechInquiryForm";

const BtechFormModal = () => {
 const { isOpen, onOpen, onClose } = useDisclosure();
 const toast = useToast();

 const handleSuccess = () => {
  onClose();
  toast({
   title: "Inquiry Submitted",
   description: "Your BTech inquiry has been received. We’ll contact you soon.",
   status: "success",
   duration: 5000,
   isClosable: true,
  });
 };

 return (
  <Box>
   <Button colorScheme="blue" onClick={onOpen}>
    Apply Now
   </Button>

   <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
    <ModalOverlay />
    <ModalContent>
     <ModalCloseButton />
     <ModalBody>
      <BtechInquiryForm onSuccess={handleSuccess} />
     </ModalBody>
    </ModalContent>
   </Modal>
  </Box>
 );
};

export default BtechFormModal;
